import { GlobalStore, tracking } from '@driftt/traffic-control'

import * as OrgSelectors from 'modules/org/selectors'

// Export this so that devs don't have to import trackers from two different places
export const trackPageView = (
  pageName: string,
  properties?: Record<string, any>
) =>
  tracking.trackPageView(
    pageName,
    OrgSelectors.orgId(GlobalStore.getState()),
    properties
  )

export const trackEvent = tracking.trackEvent

export const trackCSVDownloadClickedEvent = (
  page: string,
  csvType: string,
  startDate: string,
  endDate: string
): void =>
  trackEvent('CSV Download Clicked', {
    page,
    csv_type: csvType,
    start_date: startDate,
    end_date: endDate,
  })

export const trackClickedEvent = (
  pageName: string,
  buttonName = 'Button',
  additionalProps?: object
): void =>
  trackEvent(`${buttonName} Clicked`, {
    page: pageName,
    ...additionalProps,
  })
